<template>
	<div>
		<Navigate></Navigate>
		<div style="margin-top: 70px;"></div>
		<div class="main">
			<a class="item item1" href="gczb/index.html"></a>
			<!--<a class="item item2" href="http://old.ssjt.cn/hjgc/"></a>
			<a class="item item3" href="http://old.ssjt.cn/sbaz/"></a>
			<a class="item item4" href="http://old.ssjt.cn/ods/"></a>-->
		</div>
		<div class="bottom">
			<Copyright></Copyright>
		</div>
	</div>
</template>

<script>
import Navigate from '../../../components/ssjt/Navigate.vue'
import Copyright from '../../../components/ssjt/Copyright.vue'
export default {
	name: "Index",
	components: { Navigate, Copyright }
}
</script>

<style>
	html{ height: 100%; }
	body { margin: 0; padding: 0; height: 100%; }
	@media (max-width: 767px){ body { background: #d2d2d2 url("../../../assets/ssjt/img/mobile/background_mobile.jpg") top no-repeat; } }
	@media (min-width: 768px){ body { background: #d2d2d2 url("../../../assets/ssjt/img/background.jpg") center 50px no-repeat; } }
</style>
<style scoped>
	.item1, .item2, .item3, .item4{ transition: all 0.2s linear; }
	@media (max-width: 375px){
		.item4{ right: 0; bottom: 265px; }
		.item4:hover{ bottom: 275px; }
		.item3{ left: 0; bottom: 215px; }
		.item3:hover{ bottom: 225px; }
		.item2{ right: 0; top: 14px; }
		.item2:hover{ top: 4px; }
		.item1{ left: 0; top: 60px; }
		.item1:hover{ top: 50px; }
	}
	@media (min-width: 376px) and (max-width: 515px){
		.item4{ right: 4px; bottom: 265px; }
		.item4:hover{ bottom: 275px; }
		.item3{ left: 38px; bottom: 215px; }
		.item3:hover{ bottom: 225px; }
		.item2{ right: 15px; top: 14px; }
		.item2:hover{ top: 4px; }
		.item1{ left: 0; top: 60px; }
		.item1:hover{ top: 50px; }
	}
	@media (min-width: 516px) and (max-width: 629px){
		.item4{ right: 43px; bottom: 265px; }
		.item4:hover{ bottom: 275px; }
		.item3{ left: 85px; bottom: 215px; }
		.item3:hover{ bottom: 225px; }
		.item2{ right: 62px; top: 14px; }
		.item2:hover{ top: 4px; }
		.item1{ left: 44px; top: 60px; }
		.item1:hover{ top: 50px; }
	}
	@media (min-width: 630px) and (max-width: 767px){
		.item4{ right: 117px; bottom: 265px; }
		.item4:hover{ bottom: 275px; }
		.item3{ left: 152px; bottom: 215px; }
		.item3:hover{ bottom: 225px; }
		.item2{ right: 137px; top: 14px; }
		.item2:hover{ top: 4px; }
		.item1{ left: 118px; top: 60px; }
		.item1:hover{ top: 50px; }
	}
	@media (max-width: 767px){
		.main{ height: 500px; margin: auto; position: relative; }
		.item{ width: 100px; height: 66px; position: absolute; transition: all 0.3s linear; }
		.item4{ background: url("../../../assets/ssjt/img/mobile/ods_mobile.png") no-repeat; }
		.item4:hover{ background: url("../../../assets/ssjt/img/mobile/ods_hover_mobile.png") no-repeat; }
		.item3{ background: url("../../../assets/ssjt/img/mobile/sbaz_mobile.png") no-repeat; }
		.item3:hover{ background: url("../../../assets/ssjt/img/mobile/sbaz_hover_mobile.png") no-repeat; }
		.item2{ background: url("../../../assets/ssjt/img/mobile/hjgc_mobile.png") no-repeat; }
		.item2:hover{ background: url("../../../assets/ssjt/img/mobile/hjgc_hover_mobile.png") no-repeat; }
		.item1{ background: url("../../../assets/ssjt/img/mobile/gczb_mobile.png") no-repeat; }
		.item1:hover{ background: url("../../../assets/ssjt/img/mobile/gczb_hover_mobile.png") no-repeat; }
		.bottom{ position: fixed; bottom: 2px; width: 100%; }
	}
	@media (min-width: 768px){
		.main{ width: 860px; height: 530px; margin: auto; position: relative; }
		.item{ width: 207px; height: 139px; position: absolute; transition: all 0.3s linear; }
		.item4{ background: url("../../../assets/ssjt/img/ods.png") no-repeat; right: 10px; bottom: 125px; }
		.item4:hover{ background: url("../../../assets/ssjt/img/ods_hover.png") no-repeat; bottom: 135px; }
		.item3{ background: url("../../../assets/ssjt/img/sbaz.png") no-repeat; left: 70px; bottom: 35px; }
		.item3:hover{ background: url("../../../assets/ssjt/img/sbaz_hover.png") no-repeat; bottom: 45px; }
		.item2{ background: url("../../../assets/ssjt/img/hjgc.png") no-repeat; right: 38px; top: 15px; }
		.item2:hover{ background: url("../../../assets/ssjt/img/hjgc_hover.png") no-repeat; top: 5px; }
		.item1{ background: url("../../../assets/ssjt/img/gczb.png") no-repeat; left: 0; top: 110px; }
		.item1:hover{ background: url("../../../assets/ssjt/img/gczb_hover.png") no-repeat; top: 100px; }
		.bottom{ margin-top: 180px; }
	}
</style>